import { LoginHandlerPropsT } from "../../Types";
import { Axios } from "../../Config";

export const LoginHandler = async (data: LoginHandlerPropsT) => {
  return Axios.post("/auth/login", data);
};
